export const serverUrl = process.env.REACT_APP_SERVER_URL
export const clientUrl = process.env.REACT_APP_CLIENT_URL

const localAuthDomain = "http://localhost:9099"
export const authDomain =  localAuthDomain
export const environment = process.env.REACT_APP_ENVIRONMENT
